function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M136.828 144.857c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M137.998 145.525c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826-2.671-3.826-5.966-3.826c-3.294 0-5.965 1.713-5.965 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M137.998 145.525v3.538c0 2.113 2.67 3.826 5.965 3.826s5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M147.356 190.923L108.62 161.43l37.212-28.332 38.736 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M184.567 176.823l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m75.948 55.122v13.52m-75.948-14.682v14.231m38.737-52.93v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M184.567 190.073l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M184.567 203.323l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M184.567 216.573l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M184.567 230.823l-37.21 28.332-38.738-29.493m75.948-13.071v14.232m-75.948-15.393v14.232m38.737 15.261v14.658m0 12.824l-38.737-29.493m38.737 15.261v14.658m0 12.824l-38.737-29.493m0-14.232v14.232m38.737 15.261v14.658m0 12.824l-38.737-29.493m0-14.232v14.232m38.737 15.261v14.658"
}), React.createElement("path", {
  d: "M177.738 256.24c0 2.114 2.671 3.827 5.966 3.827 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M178.908 256.909c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M178.908 256.909v3.538c0 2.113 2.67 3.826 5.966 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M185.997 300.064l-38.737-27.622 37.212-28.33 38.737 27.62z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M223.209 285.964l-37.212 28.332-38.737-29.493m38.737 15.261v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M223.209 299.714l-37.212 28.332-38.737-29.493m38.737 15.261v14.658"
}), React.createElement("path", {
  d: "M231.744 186.023c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M232.914 186.692c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826s-2.671-3.826-5.966-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M232.914 186.692v3.538c0 2.113 2.67 3.826 5.966 3.826 3.295 0 5.966-1.713 5.966-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M215.66 173.023c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M216.83 173.692c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826s-2.671-3.826-5.965-3.826c-3.295 0-5.966 1.713-5.966 3.826z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M216.83 173.692v3.538c0 2.113 2.672 3.826 5.967 3.826 3.294 0 5.965-1.713 5.965-3.826v-3.538",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M223.44 219.566l-38.737-29.493 37.211-28.332 38.737 29.493z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M260.651 204.008l-37.212 28.996-38.736-29.493m38.737 16.055v10.432"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M260.651 216.576L223.44 245.57l-38.736-28.998m38.736 12.768v14.658"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M260.651 229.24l-37.212 30.332-38.736-28.788m38.737 12.556v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658m37.211-14.758l-37.212 28.332m.001-14.232v14.658"
}), React.createElement("path", {
  d: "M196.08 117.641c0 8.716 7.066 15.782 15.782 15.782 8.716 0 15.782-7.066 15.782-15.782 0-8.716-7.066-15.782-15.782-15.782-8.716 0-15.782 7.067-15.782 15.782",
  fill: "#FFF"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M209.578 116.111l6.373 6.374 11.79-11.79m-28.488 6.36H165.57v-74.68h53.488V97.63m-37.214-45.036h21.95m-30.276 14.002h36.71m-36.71 13.624h36.71m-36.71 13.624h36.71m-24.616 13.624h12.001"
}), React.createElement("path", {
  d: "M203.719 117.247c0 8.118 6.58 14.7 14.698 14.7 8.119 0 14.7-6.582 14.7-14.7 0-8.118-6.581-14.699-14.7-14.699-8.118 0-14.698 6.581-14.698 14.7zm-31.751-10.426a3.835 3.835 0 1 0 7.67 0 3.835 3.835 0 0 0-7.67 0z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M146.572 163.9s-7.479 5.401-7.207 5.401l8.356 6.34-1.149-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M147.576 164.652s-7.48 5.402-7.208 5.402l8.357 6.34-1.15-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M148.725 176.393v3.555l-8.357-6.34v-3.555 2.531"
}), React.createElement("path", {
  d: "M203.239 263.232s-7.479 5.402-7.208 5.402l8.357 6.34-1.149-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M204.243 263.985s-7.48 5.402-7.208 5.402l8.356 6.34-1.148-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M205.391 275.727v3.555l-8.356-6.34v-3.555 2.53"
}), React.createElement("path", {
  d: "M187.572 274.9s-7.479 5.401-7.207 5.401l8.356 6.34-1.149-11.742z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M188.576 275.652s-7.48 5.402-7.208 5.402l8.357 6.34-1.15-11.742z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M189.725 287.393v3.555l-8.357-6.34v-3.555 2.531"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M154.141 158.72l6.17 4.78 7.373-5.397-6.158-4.833z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M155.332 158.72l6.17 4.78 7.374-5.397-6.16-4.833zm13.716-.573l.01 3.944c-.042.02-7.462 5.418-7.462 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M155.166 158.654v3.849l6.336 4.847v-3.881"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M198.141 188.886l6.17 4.781 7.373-5.397-6.158-4.834z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M199.332 188.886l6.17 4.781 7.374-5.397-6.16-4.834zm13.716-.572l.01 3.944c-.042.019-7.462 5.418-7.462 5.418"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M199.166 188.82v3.85l6.336 4.846v-3.881"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M122.364 161.777l-.601-4.373 4.974-2.572 6.431 1.715.513 4.03-4.544 3.357z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M123.364 162.005l-.256-4.373 4.629-2.572 6.431 1.715.514 4.03-4.545 3.536z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M134.683 160.747v3.316l-4.46 3.536-6.773-2.336-.086-3.258m6.773 2.336l.086 3.258"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M217.364 202.777l-.601-4.373 4.974-2.572 6.431 1.715.513 4.03-4.544 3.357z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M218.364 203.005l-.256-4.373 4.629-2.572 6.431 1.715.514 4.03-4.545 3.536z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M229.683 201.747v3.316l-4.46 3.536-6.773-2.336-.086-3.258m6.773 2.336l.086 3.258M261 191v80"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_4.svg